<script>
    import {PATH_PREFIX} from '../../apiUrls.js';

    import { onMount } from 'svelte';
    import { get, submit } from '../../utils.js';

    import Button from '../Button.svelte';
    import DataTable from '../DataGrid/DataTable.svelte';
    import ConditionalActionColumn from '../DataGrid/ColumnRenderers/ConditionalActionColumn.svelte';
    import ConfirmationModal from '../ConfirmationModal.svelte';
    import DateTimeColumn from '../DataGrid/ColumnRenderers/DateTimeColumn.svelte';
    import ExpiredColumn from '../DataGrid/ColumnRenderers/ExpiredColumn.svelte';
    import MediaColumn from '../DataGrid/ColumnRenderers/MediaColumn.svelte';
    import Modal from '../Modal.svelte';
    import TagDisplayColumn from '../DataGrid/ColumnRenderers/TagDisplayColumn.svelte';
    import ToolDetail from './ToolDetail.svelte';
    import ToolForm from './ToolForm.svelte';
    import {sgettext} from '../../i18n.js';

    import {
        tool as toolStore,
        tools as toolListStore,
    } from './store.js';

    export let listUrl = `${PATH_PREFIX}/sw/api/elements_database/globaltools`;

    const detailModalId = 'detailGlobalTool';
    const expireModalId = 'expireGlobalTool';
    var keyword = '';
    let currentPage = 1;
    let total = 0;
    let globalTools = [];
    let toolForm;

    let actions = {
        details: {
            label: sgettext('$$DETAILS$$'),
            handler: (event, item) => {
                toolStore.set(item);
                jQuery(`#${detailModalId}`).modal('show');
            }
        },
    }

    let conditionalActions = {
        edit: {
            label: sgettext('$$EDIT$$'),
            handler: (event, item) => {
                toolStore.set(item);
                openEdit();
            }
        },
        expire: {
            label: sgettext('$$EXPIRE$$'),
            handler: (event, item) => {
                toolStore.set(item);
                jQuery(`#${expireModalId}`).modal('show');
            }
        }
    }

    let columns = {
        image: {
            label: sgettext('$$TOOL_IMAGE$$'),
            renderer: MediaColumn,
            width: '160px'
        },
        name: {
            label: sgettext('$$TOOL_NAME$$'),
            width: '20%'
        },
        tags: {
            label: sgettext('$$TOOL_TAGS$$'),
            renderer: TagDisplayColumn,
            width: '15%'
        },
        description: {
            label: sgettext('$$DESCRIPTION$$'),
            width: '20%'
        },
        created_date: {
            label: sgettext('$$DATE_CREATED$$'),
            renderer: DateTimeColumn,
            width: '15%'
        },
        expired: {
            label: sgettext('$$STATUS$$'),
            renderer: ExpiredColumn,
            width: '30px'
        },
        actions: {
            label: '',
            renderer: ConditionalActionColumn,
            props: {
                actions: actions,
                conditionalKey: 'expired',
                conditionalActions: conditionalActions,
                conditionalValue: false,
                showActionLabel: true,
            },
            width: '15%',
        }
    }

    function changePage(params) {
        currentPage = params.page;
        fetchResults();
    }

    function closeDetail() {
        jQuery(`#${detailModalId}`).modal('hide');
    }

    function addTool() {
        let tool = {
            name: '',
            description: '',
            image: null,
            tags: [],
            specifications: [{
                id: '',
                description: '',
                image: null,
                tags: '',
                deleted: false
            }],
            specification_images: []
        };
        toolStore.set(tool);

        openEdit();
    }

    function openEdit() {
        jQuery(`#${detailModalId}`).modal('hide');
        toolForm.$set({editId: $toolStore.id});
        setTimeout(() => {
            jQuery(`#globalToolForm`).modal('show');
        }, 400);
    }


    function cancelExpire() {
        jQuery(`#${expireModalId}`).modal('hide');
    }

    function handleExpire() {
        var deleteUrl = `${listUrl}/${$toolStore.id}/`;
        jQuery(`#${expireModalId}`).modal('hide');
        submit(deleteUrl, 'DELETE');
        var tools = $toolListStore;
        tools.forEach(e => {
            if (e.id === $toolStore.id) {
                e.expired = true;
            }
        });
        toolListStore.set(tools);
    }

    function handleKeyDown(event) {
        if (event.keyCode == 13) {
            filterResults();
        }
    }

    function filterResults() {
        currentPage = 1;
        fetchResults();
    }

    function clearResults() {
        keyword = '';
        fetchResults();
    }

    async function fetchResults() {
        var url = `${listUrl}/?page=${currentPage}`;
        if (keyword !== '') {
            url = `${url}&search=${keyword}`;
        }
        const resp = await get(url);
        const re = await resp.json();
        try {
            total = re.count;
            toolListStore.set(re.results);
        } catch (err) {
            console.error(err);
            total = 0;
            toolListStore.set([]);
        }
    }

    onMount(() => {
        fetchResults();
    });

</script>

    <div class="d-flex justify-content-between align-items-center">
        <h1 class="text-primary">{sgettext('$$GLOBAL_TOOLS$$')}</h1>
        <Button type="primary" name={sgettext("$$ADD_TOOL$$")} on:click={addTool}>
            <span slot='icon'><i class="fa fa-plus"></i></span>
        </Button>
    </div>
    <div class="form form-inline mb-3">
        <div class="input-group mr-2">
            <label for="keywordSearch">{sgettext('$$KEYWORD_1$$')}</label>
            <input type='text' class="form-control ml-2" bind:value={keyword} on:keydown={handleKeyDown} />
        </div>
        <Button type="outline-primary" on:click={filterResults} name={sgettext("$$FILTER_1$$")} />
        <Button type="outline" on:click={clearResults} name={sgettext("$$CLEAR_FILTER$$")} />
    </div>
<DataTable
    {columns}
    rows={$toolListStore}
    emptyLabel={sgettext('$$RESULTS_FOUND_1$$')}
    showFooter={total != 0}
    total={total}
    perPage={25}
    currentPage={currentPage}
    changePage={changePage}
    footerColSpan={7}
            />

<ToolForm
    bind:this={toolForm}
    id="globalToolForm"
    title={sgettext("$$GLOBAL_TOOL$$")}
/>

<Modal
    id={detailModalId}
    title={sgettext("$$TOOL_DETAILS$$")}
    large={true}>
    <div slot="body">
        <ToolDetail tool={$toolStore} />
    </div>
    <div slot="footer">
        <button
            type="button"
            class="btn btn-secondary"
            on:click={closeDetail}
            data-dismiss="modal">{sgettext('$$CLOSE$$')}</button>
        {#if !$toolStore.expired}
        <button
            type="button"
            on:click={openEdit}
            class="btn btn-primary">{sgettext('$$EDIT_TOOL$$')}</button>
        {/if}
    </div>
</Modal>

<ConfirmationModal
    id={expireModalId}
    title={sgettext("$$EXPIRE_GLOBAL_TOOL$$")}
    onYes={handleExpire}
    onNo={cancelExpire} >

    <div slot='message'>
        <div>{sgettext('$$SURE_WANT_EXPIRE_TOOL_1$$')}</div>
    </div>
</ConfirmationModal>
